import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

const DownloadAutoresponseWordButton = (props) => {

    const handleClick = (e) => {
        e.preventDefault();

        let submission_id = props.record.submission_id;
        if (typeof submission_id === 'undefined') {
            submission_id = props.record.id;
        }

        const url = `${window.__rest_uri}/v2-download-doc-autoresponse/${submission_id}?authToken=${localStorage.getItem('authToken')}`;

        window.open(url, '_blank');
    };

    return (
        <React.Fragment>
            <Button variant="contained" color="secondary" onClick={handleClick}>
                DOC
            </Button>
        </React.Fragment>
    );
};

DownloadAutoresponseWordButton.propTypes = {
    record: PropTypes.object
};

export default DownloadAutoresponseWordButton;